<template>
  <div class="itinerary-list">
    <div class="header">
      <div class="heade-label t-title sm mb-m">
        <span class="loading-text-itinerary" v-if="isSolutionLoading">Loading Your <strong>Itinerary</strong></span>
        <span v-else id="itinerary-section">Itinerary</span>
      </div>
    </div>
    <article class="solution__day" v-for="date in [...solutionDates[0]]" :key="date.label">
      <ItineraryCard
        v-for="item in dateExperiences[date.label].stays"
        :key="item.id"
        :activity="item"
        @onDetailsClick="onShowDetails(item, date)"
        @onBookClick="onBookItineraryClick(item, date)"
        :isLoading="isSolutionLoading"
      />
    </article>
    <article class="solution__day" v-for="(date, index) in solutionDates" :key="date.label + index">
      <div class="day__date" v-if="dateExperiences[date.label].all.length">
        <h2 class="day__label">
          <strong>{{ date.label }},</strong> {{ date.description }}
        </h2>
      </div>
      <div class="day__activities">
        <ItineraryCard
          v-for="item in dateExperiences[date.label].all"
          :key="item.id"
          :activity="item"
          @onDetailsClick="onShowDetails(item, date)"
          @onBookClick="onBookItineraryClick(item, date)"
          @image-click="onShowDescription(item)"
          :isLoading="isSolutionLoading"
        >
        </ItineraryCard>
      </div>
    </article>
  </div>
</template>

<script>
import Vue from 'vue';
import VueCompositionAPI, {computed} from '@vue/composition-api';
Vue.use(VueCompositionAPI);

import {useRouter} from '@/router';
import {RouterAliases} from '@/router/routerAliases';
import {useExpList} from '@components/explore-page/exp-list/exp-list';
import ItineraryCard from './itinerary-card';

import '@mobi-components/amex-bluesky-components/dist/amex-bluesky-components.css';
import '@mobi-components/amex-poi-details-view/dist/amex-poi-details-view.css';

export default {
  name: 'ItineraryList',
  components: {
    ItineraryCard,
  },
  props: {
    removedItems: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, {emit, root}) {
    const removedItems = computed(() => {
      return props.removedItems;
    });

    const expListProps = useExpList(root, emit, removedItems);

    const onBookItineraryClick = (item) => {
      window.open(item.bookingUrl, '_blank');
    };

    const onShowDetails = (item) => {
      window.open(item.detailsUrl, '_blank');
    };

    const onShowDescription = (item) => {
      const router = useRouter();
      router.push({name: RouterAliases.POI_DETAILS_VIEW, params: {poiId: item.poiId}});
    };

    return {
      ...expListProps,
      onBookItineraryClick,
      onShowDetails,
      onShowDescription,
    };
  },
};
</script>

<style scoped lang="scss">
@import '@components/solution-views/vue-transitions.scss';

.itinerary-list {
  max-width: var(--page-container-width, 1260px);
  margin: 0px auto 40px;
  --flight-pic-size: 140px;
}

.select-flight {
  cursor: pointer;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.day__date:first-child:before {
  content: '';
  height: 1px;
  border-top: 1px solid #e7e7e7;
  position: relative;
  width: 100%;
  display: block;
  z-index: 0;
}

.solution__day {
  position: relative;
  margin-bottom: 10px;
}

.day__label {
  margin: 0px;
  padding: 8px 0 0 0;

  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 118.14%;
  letter-spacing: -0.005em;
  color: rgba(7, 29, 59, 0.5);

  & > strong {
    color: #071d3b;
  }
}

.day__activities {
  position: relative;
  top: -5px;
}

.b-explore-all {
  font-size: var(--font-size-sm);
  padding-right: 16px;
  position: relative;
  border: 0;
  appearance: none;
  background-color: transparent;
  color: var(--font-color-light);
  line-height: 30px;
  height: 26px;
  cursor: pointer;
}
.b-explore-all::after {
  content: '';
  top: 0;
  right: 0;
  position: absolute;
  width: 16px;
  height: 100%;
  background-image: url("data:image/svg+xml,%3Csvg width='9' height='11' viewBox='0 0 9 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9 5.5L0.75 10.2631L0.75 0.73686L9 5.5Z' fill='%23A3ABB6'/%3E%3C/svg%3E%0A");
  background-size: 8px;
  background-position: center right;
  background-repeat: no-repeat;
  opacity: 0.5;
  transition: transform 0.2s linear;
  transform-origin: 75% center;
  will-change: transform;
}
.b-explore-all.active::after {
  transform: rotate(60deg);
}

.icon {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  font-size: 100px;
  color: #a3abb6;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-text-itinerary {
  position: relative;
  left: 30px;
}

.loading-text-itinerary + span {
  text-transform: lowercase;
}

.loading-text-itinerary:before {
  content: '';
  background: url('data:image/png+xml;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANiSURBVHgB3VVNa5xVFD7n3PvOO5NJMklRhjYzaZUgLtqiG0uYESK4cSHoQly46Eb/gH9C6FLc+gfEhS4EEcFYSwN+ILaIIFohQ2rGtKmTZpJ5P+45fd5+Jp1pPrprD7yf997znPucc55L9KQb7zlaP10tlWqvi4WXAvELwtbAgjKRXDHTrrEtpp2lLx4LwM+0XhPhD9hsktg8mXg8I2aqGIbJKMLlmbmrrJ+kyxc/H+XHjfoZzbTOOsfvMVkJISAIERLMNRMjgVPyZuTg3BPZNKa84WtNCRudpX0BSsfbb8Pjm1J8WOHeimvb1H4Wpu/V7Dc22sJIHd9VPAsQ+JG2m2hMhZud7x5JUWW23Qqm75Mx2CkWkg/Ovj6yvflZt3upvyuSxvxMLPIOKX3Iwt4AAmAnKme3Vn74aiRAudH6CPw+a8wCOpyw+3TQOX+e9rBKs/WuGn18m7ZindrGWL9y+saNb3u7KIoa7TNmdgbRGKIHO/Zl0rnwDe1j+Ubndzc9O12spTt5qaZR9ifycbkYlwdT7aQ4zvGSWbBeqvkFOqClbnAOMfX5bj4Q5Fv3xu4DAPooIigAcmb7g1Z+vE4HtSu/9Ih5CZcD6Q40vTwEgFqZwC3DhMxElumQxmqXkTdUNqMn6egwQAg5xnJUQsbBAh3SBmTnEuZ6wnQMz8YQAArzmrDk2Gamgt0c1jbjuOqy0ng0Fu38vZOilSIHGixl5edpbi6mA9uCp/Gk2s/Ea9r31BsFkNo/aoocWF7IQjl/Zp4Oao1kMhYXU2CvESqpvJEOAWTjtUtOfFFqBf/BcjlVOjH/4n6+a7Pt6ZKL6ljlYw/n2/i5o+sfaNH6X0FqTQDYCfCFXABEuekmmqrliU3aWkt3eV5Y8OVkppF6PcZBERIKHalMqvk1Wl9J7k0bkutys/Uquvgksh7UQg6tyaF2W87sqsZyPck0lEjH1Fw1QlvlitJWK3onpPlglVZ/Xdvpb0hN0frLMnUc50moo6IUghSgMahwHsO+jkCrpyJxlUA4BYob5CdyTAOzNbr60+rD/kaeB9pb/jeanLuJ1NeA5ElYUWHKDk0EZHg1Z9BN6Cd2m6Pu/6bOxf9G+dr7yCys/spz3jnICI+7SOKCjsC0Kab/p9u0TqfiLi0u5vTU2i2RZn5qNPtV/wAAAABJRU5ErkJggg==')
    no-repeat;
  background-position: 50%;
  animation: spin infinite linear 1s;
  position: absolute;
  top: 0.1em;
  left: -1.2em;
  width: 1em;
  height: 1em;
}

.remove-btn {
  --save-btn-color: #2c70c9;
  padding: 0 5px;
  z-index: 1;
  height: 27px;
  line-height: 29px;
  position: absolute;
  top: 10px;
  right: 10px;

  & > span {
    font-size: 0;
  }
}

.remove-btn:after {
  content: none;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
.heade-label {
  padding-top: 30px;
}

.actions {
  display: flex;
  align-items: center;
}

.include-toggle {
  padding: 10px 7px;
  transition: 0.3s ease opacity;
  --gray-scroll-thumb: #fff;
  --white: #fff;
  --toggle-bg: #dadada;
  border-radius: 4px !important;
  color: #838e9d;

  &.active {
    --toggle-bg: #e9a43d;
    --primary: #fff;
    --filter-label-color: #e9a43d;
  }
}

.include-toggle > .include-toggle-label {
  margin: 0 0.5em;
  color: var(--filter-label-color);
  position: relative;
  top: 2px;
  display: inline-block;
  font-weight: 400;
  font-size: var(--font-size-sm);
  line-height: 118.14%;
  letter-spacing: -0.005em;
}
</style>
